import React from 'react'

const CellAreaManager = ({label}) => {
        
    return (
        <td
            colSpan="1"
            className=""
            role="gridcell"
            aria-colindex="1"
            aria-selected="false"
            data-grid-col-index="5"
        >
            { label || '-' }
        </td>
    )
}

export default CellAreaManager